export function zeroSinceHH(millisSinceEpoch) {
    return new Date(millisSinceEpoch).setUTCHours(0, 0, 0, 0);
}
export function zeroSinceSS(millisSinceEpoch) {
    return new Date(millisSinceEpoch).setUTCSeconds(0, 0);
}
